import * as chat from "./chat.js";
import { get, post } from "@/api/request.js";

const api = {
  chat,
};

export const logout = async function () {
  return get(`/logout`);
};

export const modelList = async function () {
  return get(`/admin/system/use/model`);
};

export default api;
